import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {AboutItem} from "../types/about";
import {v4 as uuidv4} from "uuid";

const COLLECTION_ID = "about"

const databases = new Databases(client);

export const aboutService = {
  async list(queries: string[] = [], limit: number = 25): Promise<AboutItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const list = response.documents.map(doc => doc as unknown as AboutItem);
      return list;
    } catch (error) {
      throw error;
    }
  },

  async create(data: AboutItem): Promise<AboutItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as AboutItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },
  async update(data: AboutItem): Promise<AboutItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as AboutItem;
      return updatedItem;
    } catch (error) {
      throw error;
    }
  },
  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },

  async getById(id: string): Promise<AboutItem> {
    try {
      const current = await databases.getDocument(
        database_id,
        COLLECTION_ID,
        id
      ) as unknown as AboutItem;

      return current;
    } catch (error) {
      throw error;
    }
  }

}